import script from "./PageHeaderHero.vue?vue&type=script&setup=true&lang=js"
export * from "./PageHeaderHero.vue?vue&type=script&setup=true&lang=js"

import "./PageHeaderHero.vue?vue&type=style&index=0&id=41389666&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/musora-web-platform/musora-web-platform/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41389666"]])

export default __exports__